export default __webpack_public_path__ + "static/media/empty_products.518c24de.png";